import React, { useContext } from "react";
import { Container, Grid, Box } from "@mui/material";
import CcpSchoolBreadCrumbs from "../../Layout/CcpSchoolBreadCrumbs";
import { SchoolContext } from "../../../config/SchoolContext";
import SSID from "./inc/SSID";
import SpecialFundingFall from "./inc/SpecialFundingFall";
import SpecialFundingSpring from "./inc/SpecialFundingSpring";
import AdditionalReport from "./inc/AdditionalReports";
import { faChartSimple } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@mui/material/styles";

const CcpStudentInfo = () => {
  const { schoolId } = useContext(SchoolContext);
  const pageName = "Student Information";
  const icon = faChartSimple;
  const theme = useTheme();
  const linkColor = theme.palette.mode === "dark" ? "white" : "black";

  return (
    <Container sx={{ marginTop: "100px" }}>
      <Box sx={{ flexGrow: 1 }}>
        <CcpSchoolBreadCrumbs pageName={pageName} icon={icon} />
        <Grid container spacing={2}>
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <SSID schoolId={schoolId} linkColor={linkColor} />
          </Grid>
          <Grid item xs={6}>
            <AdditionalReport schoolId={schoolId} linkColor={linkColor} />
          </Grid>{" "}
          <Grid item xs={6}>
            <SpecialFundingFall schoolId={schoolId} linkColor={linkColor} />
          </Grid>
          <Grid item xs={6}>
            <SpecialFundingSpring schoolId={schoolId} linkColor={linkColor} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpStudentInfo;
